import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import useLocales from '../../gql/hooks/useLocales'; 

const LocaleSelector = ( { initialValue, onChange, value } ) => {
    const [ selected, setSelected ] = useState();
    const { locales, localesLoading, localesError } = useLocales();

    useEffect( () => {
        if ( initialValue !== selected ) {
            setSelected( initialValue );
        }
    }, [ initialValue ] );

    useEffect( () => {
        if ( value !== selected ) {
            setSelected( value );
        }
    }, [ value ] );
    
    /*****************************************
     * onChange is passed from the antd form
     * item. What you pass to this function 
     * will become the form item's value prop.
     *****************************************/

    const handleSelect = ( item ) => { 
        setSelected( setSelected );

        if ( onChange ) { 
            onChange( item ); 
        }  
    };

    return (
        <>
            { ( locales && !localesLoading && !localesError ) &&
                <Select
                    showSearch
                    defaultValue={ initialValue }
                    placeholder="Search..."
                    onChange={ ( item ) => handleSelect( item ) }
                    value={ selected }
                    filterOption={ ( input, option ) =>
                        ( option?.label ?? '' ).toLowerCase().includes( input.toLowerCase() )
                    }
                    options={ 
                        locales.map( i => {
                            return {
                                value: i.code,
                                label: i.label
                            };
                        } )
                    }
                />
            }
        </>
    );
};

export default LocaleSelector;
